import { zodResolver as m } from "../node_modules/@hookform/resolvers/zod/dist/zod.module.js";
import { useForm as n } from "../node_modules/react-hook-form/dist/index.esm.js";
import { defaultErrorMap as s } from "./defaultErrorMap.js";
function i({
  schema: r,
  reValidateMode: o = "onChange",
  mode: e = "onTouched",
  errorMap: t = s,
  ...u
}) {
  return n({
    resolver: m(r, { errorMap: t }),
    shouldFocusError: !0,
    delayError: 100,
    reValidateMode: o,
    mode: e,
    ...u
  });
}
export {
  i as useFormConfig
};
//# sourceMappingURL=useFormConfig.js.map
